"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _controlTextarea = _interopRequireDefault(require("@mapbox/mr-ui/control-textarea"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _forwardEvent = _interopRequireDefault(require("./forward-event"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _classnames = _interopRequireDefault(require("classnames"));

var _slugify = _interopRequireDefault(require("slugify"));

var _env = _interopRequireDefault(require("../analytics-shell/env"));

var _helpers = require("../on-this-page/helpers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var feedbackLimit = 1000; // character limit for the feedback textarea

var anonymousId = (0, _v.default)(); // creates an anonymousId fallback if user is not logged or we cant get their info

var environment = (0, _env.default)();
var location = typeof window !== 'undefined' ? window.location : undefined;

var Feedback = /*#__PURE__*/function (_React$Component) {
  _inherits(Feedback, _React$Component);

  var _super = _createSuper(Feedback);

  function Feedback(props) {
    var _this;

    _classCallCheck(this, Feedback);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "createId", function (el) {
      var section = (0, _slugify.default)(_this.props.section || 'page', {
        replacement: '-',
        lower: true
      });
      return "dr-ui--feedback-".concat(section, "-").concat(el);
    });

    _defineProperty(_assertThisInitialized(_this), "handleText", function (feedback) {
      _this.setState({
        feedback: feedback
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleYesNo", function (helpful) {
      // sets user rating to the state
      _this.setState({
        helpful: helpful
      }, function () {
        // creates event to send to Segment and sets it to the state
        _this.setState({
          event: _this.createSegmentEvent()
        }, function () {
          // sends helpful rating to Segment
          _this.sendToSegment();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitFeedback", function () {
      // sets event to the state and marks feedbackSent as true
      _this.setState({
        feedbackSent: true,
        event: _this.createSegmentEvent()
      }, function () {
        // sends event to Segment
        _this.sendToSegment(); // if enabled, sends feedback to Sentry


        if (_this.props.feedbackSentryDsn !== false) {
          _this.sendToSentry();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createSegmentEvent", function () {
      return _objectSpread(_objectSpread({
        event: 'Sent docs feedback'
      }, _this.state.user && _this.state.user.id ? {
        userId: _this.state.user.id
      } : {
        anonymousId: anonymousId
      }), {}, {
        properties: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          // true, false
          helpful: _this.state.helpful
        }, _this.state.feedback && {
          feedback: _this.state.feedback
        }), {}, {
          // name of current site (important for filtering in Mode)
          site: _this.props.site,
          // (optional) name of section for longer pagers, helpful for fitering in Mode and identifying section areas
          section: _this.props.section || undefined,
          // get page context
          page: _this.props.location || undefined
        }, _this.state.user && _this.state.user.id ? {
          userId: _this.state.user.id
        } : {
          anonymousId: anonymousId
        }), !_this.state.user && {
          anonymousId: anonymousId
        }), _this.state.user && _this.state.user.plan && {
          plan: _this.state.user.plan.id
        }), {}, {
          // get environment: staging or production
          environment: environment,
          // get full window location
          location: {
            hash: location.hash,
            host: location.host,
            hostname: location.hostname,
            href: location.href,
            origin: location.origin,
            pathname: location.pathname,
            search: location.search
          }
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sendToSegment", function () {
      // sends event to Segment via forward event webhook
      (0, _forwardEvent.default)(_this.state.event, _this.props.webhook, function (err) {
        if (err) _this.sendToSentry('error', err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sendToSentry", function (level, error) {
      // initialize Sentry project to send the feedback
      Sentry.init({
        dsn: _this.props.feedbackSentryDsn,
        maxValueLength: feedbackLimit,
        environment: environment
      }); // configure data to send with feeedback

      Sentry.configureScope(function (scope) {
        // set tag for site name
        scope.setTag('site', _this.props.site); // set tag for referrer, if available

        if ('referrer' in document) scope.setTag('referrer', document.referrer); // set tag for the user's boolean rating

        scope.setTag('helpful', _this.state.helpful); // set tag for the section of the page (if available)

        if (_this.props.section) scope.setTag('section', _this.props.section); // set tags for the user's preferred language (if available)

        if (_this.props.preferredLanguage) scope.setTag('preferredLanguage', _this.props.preferredLanguage); // set tags for the user's plan (if available)

        if (_this.state.user && _this.state.user.plan && _this.state.user.plan.id) scope.setTag('plan', _this.state.user.plan.id); // set user attributes (if available)

        if (_this.state.user) {
          Sentry.setUser(_objectSpread(_objectSpread(_objectSpread({}, _this.state.user.id && {
            username: _this.state.user.id
          }), _this.state.user.email && {
            email: _this.state.user.email
          }), _this.state.user.plan && _this.state.user.plan.id && {
            data: {
              plan: _this.state.user.plan.id
            }
          }));
        } // send error message (if available)


        if (error) Sentry.setExtra('error', error); // set the message as "info" (rather than warning)

        scope.setLevel(level || 'info');
      }); // capture the feedback as a message

      Sentry.captureMessage(_this.state.feedback);
    });

    _this.state = {
      helpful: undefined,
      feedback: undefined,
      feedbackSent: undefined,
      event: undefined,
      user: undefined
    };
    return _this;
  }

  _createClass(Feedback, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof MapboxPageShell !== 'undefined') {
        MapboxPageShell.afterUserCheck(function () {
          _this2.setState({
            user: MapboxPageShell.getUser() || undefined
          });
        });
      }
    } // creates a unique id for an element

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var feedbackLength = this.state.feedback ? feedbackLimit - this.state.feedback.length : feedbackLimit;
      var feedbackOverLimit = feedbackLength < 0;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dr-ui--feedback"
      }, this.state.helpful === undefined && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_helpers.AsideHeading, null, "Tài liệu này có hữu ích không? ", "", ""), /*#__PURE__*/_react.default.createElement("button", {
        id: this.createId('yes'),
        onClick: function onClick() {
          return _this3.handleYesNo(true);
        },
        className: "btn btn--s"
      }, "Có"), /*#__PURE__*/_react.default.createElement("button", {
        id: this.createId('no'),
        onClick: function onClick() {
          return _this3.handleYesNo(false);
        },
        className: "btn btn--s ml6"
      }, "Không")), this.state.helpful !== undefined && /*#__PURE__*/_react.default.createElement(_helpers.AsideHeading, null, "Cảm ơn phản hồi của bạn."), this.state.helpful !== undefined && this.state.feedbackSent === undefined && /*#__PURE__*/_react.default.createElement("div", {
        className: "mt12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mb6"
      }, "Nếu bạn có phản hồi cụ thể hơn", this.state.helpful === false && " về cách chúng tôi có thể cải thiện điều này ".concat(this.props.type), ", bạn có thể cung cấp nó bên dưới (tùy chọn):"), /*#__PURE__*/_react.default.createElement("div", {
        className: "relative"
      }, /*#__PURE__*/_react.default.createElement(_controlTextarea.default, {
        id: this.createId('text'),
        themeControlWrapper: "bg-white mb6",
        onChange: this.handleText,
        value: this.state.feedback
      }), /*#__PURE__*/_react.default.createElement(FeedbackCounter, {
        createId: this.createId,
        feedbackOverLimit: feedbackOverLimit,
        feedbackLength: feedbackLength
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "mb12"
      }, /*#__PURE__*/_react.default.createElement("button", {
        id: this.createId('submit'),
        disabled: this.state.feedback === undefined || this.state.feedback.length < 3 || // disable button unless more than 3 characters are typed
        feedbackOverLimit,
        className: "btn btn--s mb6 mr12 inline-block",
        onClick: this.handleSubmitFeedback
      }, "Send feedback"), feedbackOverLimit && /*#__PURE__*/_react.default.createElement(FeedbackOverlimitWarning, {
        createId: this.createId,
        feedbackLimit: feedbackLimit
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "txt-s txt-em"
      }, "Biểu mẫu này dành cho phản hồi về tài liệu. Nếu bạn có câu hỏi kỹ thuật về cách sử dụng sản phẩm eKMap Platform,", ' ', /*#__PURE__*/_react.default.createElement("a", {
        href: "https://ekgis.com.vn/ekmap-platform",
        className: "link"
      }, "contact Support"), ".")));
    }
  }]);

  return Feedback;
}(_react.default.Component); // character counter that appears in the bottom-right of the feedback textarea


var FeedbackCounter = /*#__PURE__*/function (_React$Component2) {
  _inherits(FeedbackCounter, _React$Component2);

  var _super2 = _createSuper(FeedbackCounter);

  function FeedbackCounter() {
    _classCallCheck(this, FeedbackCounter);

    return _super2.apply(this, arguments);
  }

  _createClass(FeedbackCounter, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.createId('counter'),
        className: (0, _classnames.default)('absolute bottom right mb6 mr18 txt-mono bg-lighten75 px3 txt-s', {
          'color-red': this.props.feedbackOverLimit
        })
      }, this.props.feedbackLength);
    }
  }]);

  return FeedbackCounter;
}(_react.default.Component);

FeedbackCounter.propTypes = {
  createId: _propTypes.default.func.isRequired,
  feedbackOverLimit: _propTypes.default.bool.isRequired,
  feedbackLength: _propTypes.default.number.isRequired
}; // inline warning message that will appear if the user enters > 1000 characters in the feedback textarea

var FeedbackOverlimitWarning = /*#__PURE__*/function (_React$Component3) {
  _inherits(FeedbackOverlimitWarning, _React$Component3);

  var _super3 = _createSuper(FeedbackOverlimitWarning);

  function FeedbackOverlimitWarning() {
    _classCallCheck(this, FeedbackOverlimitWarning);

    return _super3.apply(this, arguments);
  }

  _createClass(FeedbackOverlimitWarning, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("span", {
        id: this.props.createId('overlimit'),
        className: "color-red txt-s bg-red-faint round inline-block py3 px12"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "alert",
        inline: true
      }), " Your message is over the", ' ', this.props.feedbackLimit, " character limit.");
    }
  }]);

  return FeedbackOverlimitWarning;
}(_react.default.Component);

FeedbackOverlimitWarning.propTypes = {
  createId: _propTypes.default.func.isRequired,
  feedbackLimit: _propTypes.default.number.isRequired
};
Feedback.propTypes = {
  type: _propTypes.default.string,
  // type of content the user is a evaluating
  site: _propTypes.default.string.isRequired,
  // the site name, same value as the `site` value passed to ReactPageShell
  section: _propTypes.default.string,
  // name of section the feedack component falls under
  location: _propTypes.default.object.isRequired,
  // this prop is generated by batfish and provides context for the current page
  webhook: _propTypes.default.shape({
    staging: _propTypes.default.string.isRequired,
    production: _propTypes.default.string.isRequired
  }),
  // staging and production webhook URLs to send forward event data to
  preferredLanguage: _propTypes.default.string,
  // preferred code language if available
  feedbackSentryDsn: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]) // Sentry DSN (URL) to send text feedback to for issue management or "false" to not send feedback to Sentry

};
Feedback.defaultProps = {
  type: 'page',
  feedbackSentryDsn: 'https://eccc8b561b9a461990309b01d33d54e3@sentry.io/1848287'
};
var _default = Feedback;
exports.default = _default;